function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createElement } from 'react';
import PropTypes from 'prop-types';
import { FelaComponentFactory, THEME_CHANNEL } from 'fela-bindings';

import FelaTheme from './FelaTheme';

export default FelaComponentFactory(createElement, FelaTheme, _defineProperty({
  renderer: PropTypes.object
}, THEME_CHANNEL, PropTypes.object));


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fela/es/FelaComponent.js
// module id = 144
// module chunks = 0